export const report = string =>
  window?.['Honeybadger']?.notify?.(string)
